import { MARQUEE } from "@/data/content";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE.map((m) => (
      <span key={m} className="flex items-center">
        <span className="font-display italic text-2xl sm:text-3xl text-[#16302B] whitespace-nowrap px-8 sm:px-10">{m}</span>
        <span className="h-1.5 w-1.5 rotate-45 bg-[#B8874A]" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="marquee relative overflow-hidden border-b border-[#D8CFBC] bg-[#EFE9DC] py-7" data-testid="credentials-marquee">
    <div className="absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-[#EFE9DC] to-transparent pointer-events-none" />
    <div className="absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-[#EFE9DC] to-transparent pointer-events-none" />
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);
